import { useLocation } from 'react-router-dom';
import usePrevious from './usePrevious';
/**
 * Intercept location change in sync and triggers given callback
 * If you have use case: To do something on location change before
 * anything else in your component i.e. use this in your render.
 */
var useLocationChangeSync = function (onChange) {
    var location = useLocation();
    var prevLocation = usePrevious(location);
    if (!prevLocation || (prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.pathname) !== location.pathname) {
        onChange(location);
    }
};
export default useLocationChangeSync;
//# sourceMappingURL=useLocationChangeSync.js.map